import React from 'react';

import { subscribe_path } from '@routes';

import { ProButton } from '../../Button/variants';
import IconGroup from '../../Images/Rebranding/IconGroup';

const ProTeams = () => {
  return (
    <div className="mt-48 flex flex-col items-center justify-center bg-[url('https://tii.imgix.net/global/pro/GroupSubsMobile.png?auto=format')] bg-cover px-16 py-64 sm:bg-[url('https://tii.imgix.net/global/pro/GroupSubsDesktop.png?auto=format')] sm:py-80 md:py-72 lg:mt-64">
      <IconGroup className="w-[250px] sm:w-[330px]" />
      <h2 className="m-0 mb-16 mt-24 max-w-[750px] text-center font-suisse-works text-headline-sm text-primary-black md:text-headline-md">
        Equip your teams with the resources they need to get and stay ahead.
      </h2>
      <ProButton as="link" href={subscribe_path()} className="mx-16 sm:mx-0">
        Subscribe today
      </ProButton>
    </div>
  );
};

export default ProTeams;
